import React, { useState } from 'react';
import InversionesReport from './reports/InversionesReport.js';
import AgreementExportReport from './reports/AgreementExportReport.js'; // <-- NUEVO: Importar el nuevo componente
import '../../styles/Reportes.css';
import { BarChart3, Download } from 'lucide-react';

const Reportes = () => {
    const [activeTab, setActiveTab] = useState('inversiones');

    return (
        <div className="reports-section">
            <h2 className="section-title">
                <BarChart3 size={24} style={{ marginRight: '10px' }} />
                Reportes de la Plataforma
            </h2>
            <p>Análisis y visualización de datos clave.</p>

            <div className="admin-tabs">
                <button
                    onClick={() => setActiveTab('inversiones')}
                    className={activeTab === 'inversiones' ? 'active' : ''}
                >
                    Participaciones
                </button>
                {/* --- NUEVA PESTAÑA DE EXPORTACIÓN --- */}
                <button
                    onClick={() => setActiveTab('exportar')}
                    className={activeTab === 'exportar' ? 'active' : ''}
                >
                    <Download size={16} style={{ marginRight: '8px' }} />
                    Exportar Acuerdos
                </button>
            </div>

            <div className="tab-content">
                {activeTab === 'inversiones' && <InversionesReport />}
                {activeTab === 'exportar' && <AgreementExportReport />}
            </div>
        </div>
    );
};

export default Reportes;
